import { render, staticRenderFns } from "./WantedListPage.vue?vue&type=template&id=8f28fd7e&scoped=true"
import script from "./WantedListPage.vue?vue&type=script&lang=js"
export * from "./WantedListPage.vue?vue&type=script&lang=js"
import style0 from "./WantedListPage.vue?vue&type=style&index=0&id=8f28fd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f28fd7e",
  null
  
)

export default component.exports